module.exports = __webpack_public_path__ + "img/3.3fcdede3.jpg";